define(
	'BTM.PersonalizationAttributeSorting.PersonalizationAttributeSorting', [
		'Backbone',
		'SC.Configuration',
		'Backbone.CollectionView',
		'Transaction.Line.Views.Options.Selected.View',
		"Transaction.Line.Views.Option.View",
		"ProductDetails.Options.Selector.Pusher.View",
		'ProductDetails.Options.Selector.View',
		"ProductDetails.Full.View",
		"ProductViews.Option.View",
		'underscore',
		'jQuery'
	],
	function (
		Backbone,
		Configuration,
		BackboneCollectionView,
		TransactionLineViewsOptionsSelectedView,
		TransactionLineViewsOptionView,
		ProductDetailsOptionsSelectorPusherView,
		ProductDetailsOptionsSelectorView,
		ProductDetailsFullView,
		ProductViewsOptionView,
		_,
		jQuery
	) {
		'use strict';

		return {
			mountToApp: function mountToApp(container) {
				var personalizationAttributeSortingEnabled = Configuration.get('personalizationAttributeSorting.enabled');
				if (!personalizationAttributeSortingEnabled) {
					return;
				}

				var personalizationAttributeSortingBy = Configuration.get('personalizationAttributeSorting.by');
				if (personalizationAttributeSortingBy == undefined || personalizationAttributeSortingBy == null || personalizationAttributeSortingBy == "") {
					personalizationAttributeSortingBy = "index";
				}

				/*
					index: 10
					isMandatory: false
					isMatrixDimension: false
					itemOptionId: ""
					label: "2nd Name/Adult Female"
					type:
				*/
				_.extend(TransactionLineViewsOptionsSelectedView.prototype.childViews, {
					"Options.Collection": function () {
						var optionsCollection = _.sortBy(this.model.getVisibleOptions(), function (option) {
							return option.get(personalizationAttributeSortingBy);
						});
						return new BackboneCollectionView({
							collection: optionsCollection,
							childView: TransactionLineViewsOptionView,
							viewsPerRow: 1,
							childViewOptions: {
								line: this.model,
								templateName: 'selected'
							}
						});
					}
				});
				_.extend(ProductDetailsOptionsSelectorView.prototype.childViews, {
					"Options.Collection": function () {
						var optionsCollection = _.sortBy(this.model.getVisibleOptions(), function (option) {
							return option.get(personalizationAttributeSortingBy);
						});
						return new BackboneCollectionView({
							collection: optionsCollection,
							childView: ProductViewsOptionView,
							viewsPerRow: 1,
							childViewOptions: {
								line: this.model,
								item: this.model.get("item"),
								templateName: "selector",
								show_required_label: this.options.show_required_label
							}
						});
					}
				});

				_.extend(ProductDetailsFullView.prototype, {
					showOptionsPusher: function showOptionsPusher() {
						var optionsCollection = _.sortBy(this.model.getVisibleOptions(), function (option) {
							return option.get(personalizationAttributeSortingBy);
						});
						const options_values_length = _.reduce(
							optionsCollection.map(function (option) {
								if (_.isArray(option.get('values'))) {
									const invalid_values = _.filter(option.get('values'), (value) => {
										return !value.internalid;
									});

									return option.get('values').length - invalid_values.length;
								}
								return 0;
							}),
							(memo, num) => {
								return memo + num;
							},
							0
						);

						return (
							options_values_length > Configuration.get('ItemOptions.maximumOptionValuesQuantityWithoutPusher', 1)
						);
					}
				});

				ProductDetailsOptionsSelectorPusherView.prototype.getContext = _.wrap(ProductDetailsOptionsSelectorPusherView.prototype.getContext, function (fn) {
					var context = fn.apply(this, _.toArray(arguments).slice(1));
					var optionsCollection = _.sortBy(this.model.getVisibleOptions(), function (option) {
						return option.get(personalizationAttributeSortingBy);
					});
					context.selectedOptions = optionsCollection;
					return context;
				});
			}
		};
	});
